import useCrud from 'hooks/useCrud';
import { buyerDetail } from 'services/api/review';

function useBuyerDetail() {
  return useCrud({
    read: buyerDetail,
  });
}

export default useBuyerDetail;
